import { __decorate } from "tslib";
import { LitElement, customElement, html, css, property } from 'lit-element';
let CdsPagination = class CdsPagination extends LitElement {
    static get styles() {
        return [css `
      :host {
        box-sizing: border-box;
        width: 100%;
        font-size: 14px;
      }

      *, *:before, *:after {
        box-sizing: inherit;
      }

      .private-host {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: var(--cds-global-space-4);
      }

      ::slotted(input) {
        width: fit-content !important;
        border: var(--cds-alias-object-border-width-100) solid var(--cds-alias-object-border-color);
        color: #2d2d2d;
      }
    `];
    }
    render() {
        return html `<div class="private-host"><slot></slot></div>`;
    }
};
CdsPagination = __decorate([
    customElement('cds-pagination')
], CdsPagination);
export { CdsPagination };
let CdsPaginationButton = class CdsPaginationButton extends LitElement {
    constructor() {
        super(...arguments);
        this.action = 'next';
        // would use base button
        this.role = 'button';
        this.disabled = null;
        this.tabIndex = 0;
    }
    static get styles() {
        return [css `
      :host {
        cursor: pointer;
        width: 20px;
        height: 20px;
        text-align: center;
        font-size: 28px;
        line-height: 15px;
        height: 20px;
        overflow: hidden;
      }


      :host([disabled]) {
        color: #ccc;
        cursor: not-allowed;
        outline: 0;
      }
    `];
    }
    render() {
        return html `
      ${this.action === 'next' ? html `<cds-icon shape="angle" direction="right"></cds-icon>` : ''}
      ${this.action === 'last' ? html `<cds-icon shape="angle-double" direction="right"></cds-icon>` : ''}
      ${this.action === 'prev' ? html `<cds-icon shape="angle" direction="left"></cds-icon>` : ''}
      ${this.action === 'first' ? html `<cds-icon shape="angle-double" direction="left"></cds-icon>` : ''}
    `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
                this.click();
                event.preventDefault();
                event.stopPropagation();
            }
        });
        this.setAttribute('aria-label', this.action);
    }
    update(props) {
        super.update(props);
        if (props.has('disabled')) {
            this.tabIndex = this.disabled ? -1 : 0;
        }
    }
};
__decorate([
    property()
], CdsPaginationButton.prototype, "action", void 0);
__decorate([
    property({ type: String, reflect: true })
], CdsPaginationButton.prototype, "role", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], CdsPaginationButton.prototype, "disabled", void 0);
__decorate([
    property({ type: Number, reflect: true, attribute: 'tabindex' })
], CdsPaginationButton.prototype, "tabIndex", void 0);
CdsPaginationButton = __decorate([
    customElement('cds-pagination-button')
], CdsPaginationButton);
export { CdsPaginationButton };
//# sourceMappingURL=pagination.element.js.map